import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useBoolean } from 'react-use'

import agent from 'agent'
import TextButton from 'components/common/TextButton'
import useAuth from 'hooks/use-auth'
import { trans } from 'i18n/translate'
import toast from 'lib/toast'
import { Scenario } from 'types/api/scenarios/scenario'
import { messageFromResponseError } from 'utils/strings'

export const DeleteScenarioButton: React.FC<{
  onDelete?: () => void
  scenario: Scenario
}> = ({ onDelete, scenario }) => {
  const navigate = useNavigate()
  const { currentTeamId } = useAuth()
  const [isModalOpen, setIsModalOpen] = useBoolean(false)

  const handleDelete = async () => {
    try {
      await agent.delete(`/scenarios/${scenario.guid}/?teamId=${currentTeamId}`)
      toast({
        type: 'success',
        text: trans('scenarios.delete_modal.delete.success')
      })
      setIsModalOpen(false)

      if (onDelete) {
        onDelete()
      } else {
        navigate('/scenarios')
      }
    } catch (err) {
      toast({
        type: 'error',
        text: messageFromResponseError(
          err,
          trans('scenarios.delete_modal.delete.error')
        )
      })
    }
  }

  return (
    <>
      <TextButton
        data-test-delete-button
        destructive
        onClick={() => setIsModalOpen(true)}
      >
        Delete
      </TextButton>
      <Dialog
        aria-labelledby="alert-dialog-title"
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DialogTitle color="error" id="alert-dialog-title">
          {trans('scenarios.delete_modal.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {trans('scenarios.delete_modal.text')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsModalOpen(false)}>
            {trans('scenarios.delete_modal.cancel_button')}
          </Button>
          <Button
            autoFocus
            data-test-dialog-delete-button
            onClick={handleDelete}
          >
            {trans('scenarios.delete_modal.delete_button')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
